/* eslint-disable no-useless-escape */
import { KeyboardArrowDownRounded } from '@mui/icons-material';
import { CircularProgress, FormControl, FormHelperText, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAsyncAction, useStateRef } from 'app/services';
import { issueTypeFormLoad } from 'app/store/issue';
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
const assignRef = (ref, value) => {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
};
const IssueForm = forwardRef((props, ref) => {
    const filesRef = useRef(null);
    const theme = useTheme();
    const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(false);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(issueTypeFormLoad);
    const { typeItems } = useSelector((state) => state.issue);
    const { onSubmit } = props;
    const { control, register, formState, handleSubmit, watch, setValue } = useForm({
        defaultValues: {
            title: '',
            type_id: '',
            name: '',
            number: '',
            trailer_number: '',
            description: '',
            attachments: [],
        },
    });
    const typeId = watch('type_id');
    const attachmentsValue = watch('attachments');
    useImperativeHandle(ref, () => ({
        handleFormSubmit: () => {
            handleSubmit((data) => onSubmit({
                title: data.title,
                type_id: parseInt(String(data.type_id), 10),
                name: data.name ? data.name : undefined,
                number: data.number ? data.number : undefined,
                trailer_number: data.trailer_number ? data.trailer_number : undefined,
                description: data.description,
                attachments: data.attachments ? data.attachments : [],
            }))();
        },
    }));
    const handleInputFileChange = (e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onerror = () => setValue('attachments', []);
        reader.onload = () => {
            var _a;
            const result = String((_a = reader.result) !== null && _a !== void 0 ? _a : '');
            const attachment = {
                ext: '.' + file.type.split('/')[1],
                name: file.name,
                type: file.type,
                base64: result.split('base64,')[1],
            };
            setValue('attachments', [attachment]);
        };
    };
    useEffect(() => {
        if (firstUpdateRef.current !== undefined) {
            setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
        }
    }, [firstUpdateRef.current]);
    useEffect(() => {
        var _a, _b;
        if (typeId) {
            setValue('title', (_b = (_a = typeItems.find((issue) => issue.id === typeId)) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '');
        }
    }, [typeId]);
    useEffect(() => {
        fetchData();
    }, []);
    return (React.createElement("form", null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { error: !!formState.errors.type_id, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0422\u0435\u043C\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B"),
                    isFetchLoading && (React.createElement(OutlinedInput, { disabled: true, endAdornment: React.createElement(InputAdornment, { position: 'end' },
                            React.createElement(CircularProgress, { size: 16 })) })),
                    !isFetchLoading && (React.createElement(Controller, { name: 'type_id', control: control, render: ({ field }) => (React.createElement(Select, Object.assign({ label: '\u0422\u0435\u043C\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B', IconComponent: KeyboardArrowDownRounded, notched: firstUpdate, value: field.value, onChange: field.onChange, MenuProps: {
                                sx: {
                                    '.MuiPaper-root': {
                                        maxHeight: 200,
                                        overflow: 'auto',
                                        marginTop: '1px',
                                    },
                                    '.MuiPaper-root:before': {
                                        display: 'none',
                                    },
                                },
                            } }, register(field.name, {
                            pattern: /^[A-Za-zА-Яа-я0-9_\W\s]+$/iu,
                            required: true,
                        })), typeItems.map((value, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, value: value.id }, value.title))))) })),
                    React.createElement(FormHelperText, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u043C\u0443 \u0432\u043E\u043F\u0440\u043E\u0441\u0430"))),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.number, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430"),
                    React.createElement(Controller, { name: 'number', control: control, render: ({ field }) => (React.createElement(InputMask, Object.assign({ mask: 'A999AA 999', maskChar: '', value: field.value, onChange: field.onChange, formatChars: {
                                '9': '[0-9]',
                                A: '[АВЕКМНОРСТУХ]',
                            } }, register(field.name, {
                            pattern: /^([АВЕКМНОРСТУХ]{1}[0-9]{3}[АВЕКМНОРСТУХ]{2}\s[0-9]{2,3})?$/iu,
                            required: true,
                        })), (inputProps) => (React.createElement(OutlinedInput, Object.assign({ label: '\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430', notched: firstUpdate, fullWidth: true, placeholder: '\u0410000\u0410\u0410 77' }, inputProps, { ref: (node) => {
                                assignRef(inputProps.ref, node);
                                field.ref(node);
                            } }))))) }),
                    React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0410000\u0410\u0410 77"))),
            React.createElement(Grid, { item: true, xs: 6 },
                React.createElement(FormControl, { error: !!formState.errors.trailer_number, margin: 'normal', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0438\u0446\u0435\u043F\u0430"),
                    React.createElement(Controller, { name: 'trailer_number', control: control, render: ({ field }) => (React.createElement(InputMask, Object.assign({ mask: 'A\u04109999 999', maskChar: '', value: field.value, onChange: field.onChange, formatChars: {
                                '9': '[0-9]',
                                A: '[АВЕКМНОРСТУХ]',
                            } }, register(field.name, {
                            pattern: /^([АВЕКМНОРСТУХ]{2}\d{4}\s\d{2}|[АВЕКМНОРСТУХ]{1}\d{3}[АВЕКМНОРСТУХ]{2}\s\d{2}|[АВЕКМНОРСТУХ]{1}\d{3}[АВЕКМНОРСТУХ]{2}\s\d{3}|[A-Z]{1}\d{4}[A-Z]\-\d{1}|[A-Z]{2}\s\d{4}\-\d{1}|\d{4}\s[A-Z]{2}\-\d{1}|\d{2}[A-Z]{2}\d{3}|\d{2}\-[A-Z]{2}\-\d{3})$/,
                        })), (inputProps) => (React.createElement(OutlinedInput, Object.assign({ label: '\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440 \u043F\u0440\u0438\u0446\u0435\u043F\u0430', notched: firstUpdate, fullWidth: true, placeholder: '\u0410\u04100000 77' }, inputProps, { ref: (node) => {
                                assignRef(inputProps.ref, node);
                                field.ref(node);
                            } }))))) }),
                    React.createElement(FormHelperText, null, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0410\u04100000 77"))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { error: !!formState.errors.description, margin: 'none', variant: 'outlined', fullWidth: true },
                    React.createElement(InputLabel, { disableAnimation: firstUpdate }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B"),
                    React.createElement(OutlinedInput, Object.assign({ label: '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B', notched: firstUpdate, multiline: true, fullWidth: true, minRows: 7, sx: { padding: 0 } }, register('description', {
                        pattern: /^[A-Za-zА-Яа-я0-9_\-\W\s]+$/iu,
                        required: true,
                    }))),
                    React.createElement(FormHelperText, null, "\u041E\u043F\u0438\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443 \u0438\u043B\u0438 \u0437\u0430\u0434\u0430\u0439\u0442\u0435 \u0412\u0430\u0448 \u0432\u043E\u043F\u0440\u043E\u0441"))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormControl, { error: !!formState.errors.attachments, margin: 'none', variant: 'outlined', fullWidth: true, sx: {
                        marginTop: '12px',
                        label: {
                            display: 'flex',
                        },
                        '.MuiButton-root': {
                            width: '40%',
                            marginLeft: '12px',
                        },
                    } },
                    React.createElement("label", { ref: filesRef, htmlFor: 'upload-photo' },
                        React.createElement("input", { id: 'upload-photo', name: 'upload-photo', type: 'file', accept: 'image/png, image/jpeg', style: { display: 'none' }, onChange: handleInputFileChange }),
                        React.createElement(OutlinedInput, { notched: true, placeholder: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0430\u0439\u043B', readOnly: true, onClick: () => { var _a; return (_a = filesRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, value: attachmentsValue.length ? attachmentsValue[0].name : '', fullWidth: true })),
                    React.createElement(FormHelperText, null, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u043C .png, .jpeg \u043D\u0435 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0449\u0438\u043C \u043B\u0438\u043C\u0438\u0442 50Mb"))))));
});
IssueForm.displayName = 'IssueForm';
export default IssueForm;
